import { csx } from '@vtex/admin-ui'
import React from 'react'
import { useIntl } from 'react-intl'

import { useFormatCurrency } from '../../../../hooks'

export type MethodLabelPriceProps = {
  price: number | null
  selected: boolean
}

export const MethodLabelPrice = ({
  price,
  selected,
}: MethodLabelPriceProps) => {
  const formatCurrency = useFormatCurrency()
  const { formatMessage } = useIntl()
  const value = price ?? 0

  const color = (() => {
    if (selected) {
      return 'blue40'
    }

    if (price === 0) {
      return '$positive'
    }

    return '$primary'
  })()

  return (
    <p className={csx({ color })}>
      {value === 0
        ? formatMessage({ id: 'freeShipping' })
        : formatCurrency(value / 100)}
    </p>
  )
}
